import { IEnumerationOption } from "../../../shared/definitions/datatypes";

const allOperators = [
  { id: "=", name: "Equals (=)" },
  { id: "!=", name: "Not Equals (!=)" },
  { id: ">", name: "Greater Than (>)" },
  { id: "<", name: "Less Than (<)" },
  { id: ">=", name: "Greater Than or Equal (>=)" },
  { id: "<=", name: "Less Than or Equal (<=)" },
];

export const datetimeAllowedOperators = [
  { id: "=", name: "Equals (=)" },
  { id: "!=", name: "Not Equals (!=)" },
];

export const textAllowedOperators = [
  { id: "=", name: "Equals (=)" },
  { id: "!=", name: "Not Equals (!=)" }
];

export const numberAllowedOperators = [
  { id: "=", name: "Equals (=)" },
  { id: "!=", name: "Not Equals (!=)" },
  { id: ">", name: "Greater Than (>)" },
  { id: "<", name: "Less Than (<)" },
  { id: ">=", name: "Greater Than or Equal (>=)" },
  { id: "<=", name: "Less Than or Equal (<=)" }
];

export const booleanAllowedOperators = [
  { id: "=", name: "Is (True/False)" },
  { id: "!=", name: "Is Not (True/False)" },
];

export interface IAggregation {
  id: string;
  name: string;
  datatype: string;
}

export const allAggregations: IAggregation[] = [
  { id: "count", name: "Count", datatype: "integer" },
  { id: "distinct_count", name: "Distinct Count", datatype: "integer" },
  { id: "sum", name: "Sum", datatype: "float" },
  { id: "min", name: "Minimum", datatype: "float" },
  { id: "max", name: "Maximum", datatype: "float" },
  { id: "avg", name: "Average", datatype: "float" },
];

export const datetimeAllowedAggregations: IAggregation[] = [
  { id: "count", name: "Count", datatype: "integer" },
  { id: "distinct_count", name: "Distinct Count", datatype: "integer" },
  { id: "min", name: "Earliest (min)", datatype: "datetime" },
  { id: "max", name: "Latest (max)", datatype: "datetime" },
];

export const textAllowedAggregations: IAggregation[] = [
  { id: "count", name: "Count", datatype: "integer" },
  { id: "distinct_count", name: "Distinct Count", datatype: "integer" },
];

export const numberAllowedAggregations: IAggregation[] = [
  { id: "count", name: "Count", datatype: "integer" },
  { id: "distinct_count", name: "Distinct Count", datatype: "integer" },
  { id: "sum", name: "Sum", datatype: "float" },
  { id: "min", name: "Minimum", datatype: "float" },
  { id: "max", name: "Maximum", datatype: "float" },
  { id: "avg", name: "Average", datatype: "float" },
];

export const booleanAllowedAggregations: IAggregation[] = [
  { id: "count", name: "Count", datatype: "integer" },
  { id: "distinct_count", name: "Distinct Count", datatype: "integer" },
];

export const operatorByType: { [key: string]: IEnumerationOption[] } = {
  text: textAllowedOperators,
  datetime: datetimeAllowedOperators,
  float: numberAllowedOperators,
  integer: numberAllowedOperators,
  boolean: booleanAllowedOperators,
  reference: textAllowedOperators,
  all: allOperators
};

export const aggregationByType: { [key: string]: IAggregation[] } = {
  text: textAllowedAggregations,
  datetime: datetimeAllowedAggregations,
  float: numberAllowedAggregations,
  integer: numberAllowedAggregations,
  boolean: booleanAllowedAggregations,
  reference: textAllowedAggregations,
  all: allAggregations
};

export const stateOptions = [
  { id: "Open", name: "Open" },
  { id: "Active", name: "Active" },
  { id: "Finished", name: "Finished" }
];

export const dateOptions = [
  { id: "last_7_days", name: "Last 7 Days" },
  { id: "last_30_days", name: "Last 30 Days" },
  { id: "last_365_days", name: "Last 365 Days" },
  { id: "current_week", name: "Current Week" },
  { id: "current_month", name: "Current Month" },
  { id: "current_year", name: "Current Year" },
  { id: "past_week", name: "Past Week" },
  { id: "past_month", name: "Past Month" },
  { id: "past_year", name: "Past Year" },
];